module.exports = __webpack_public_path__ + "img/139.3fbdb91a.jpg";